import axios from '../axios'

const getDetailStudentApi = async (id) => { 
    return await axios.get("api/teacher/students/" + id)
}

export default getDetailStudentApi
